import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'timeago' })
export class TimeagoPipe implements PipeTransform {

  transform(time: any, format?: any): any {

    if(!time) {
      return '...';
    }

    //time = time.seconds*1000;

    const date = new Date(time);
    const now = new Date();

    let result;

    if (format === 'hrsOrDate') {
      if(date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth() && date.getDate() === now.getDate()) {
        result = formatDate(date, 'HH:mm', 'en-EN');
      }
      else {
        result = formatDate(date, 'dd/MM/YYYY HH:mm', 'en-EN');
      }

      return result;
    }
    else {
      if(date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth()) {
        if(date.getDate() === now.getDate()) {
          result = formatDate(date, 'HH:mm', 'en-EN');
        }
        else if(date.getDate() === (now.getDate()-1)){
          result = 'Ayer';
        }
      }

      return result || formatDate(date, 'dd/MM/YYYY', 'en-EN');
    }
  }

}
